import React from 'react';
import './nlp.css';

const m_attend = () => {
    return (
        <div className="m_attend__wrap">
            <div className="m_learning container">
                <h3 className="m_learning--title">Why Attend?</h3>
                <p className="m_learning--text inner_pages--text">Several of the best minds and biggest names in data science will be presenting.</p>
                <p className="m_learning--text inner_pages--text">Network with attendees from leading data science companies to learn how others are tackling similar problems.</p>
                <p className="m_learning--text inner_pages--text">Gain quality training in the hottest data science topics, tools, and languages.</p>
                <p className="m_learning--text inner_pages--text">Learn the latest in data science from industry leaders without having to make room in the budget — tickets are surprisingly inexpensive.</p>
            </div>
        </div>
    );
};

export default m_attend;